import React, { useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./venue.css";
import half from "../../assets/images/star-half-yellow-icon.svg";
import PlaceDetails from "../../components/place-details/PlaceDetails";
import LocalAttraction from "../../components/local-attraction/LocalAttraction";
import Reviews from "../../components/reviews/Reviews";
import { toast, ToastContainer } from "react-toastify";
import AddAttraction from "./AddAttraction";
import EditAttraction from "./EditAttraction";
import ConfirmModal from "../../components/ConfirmModal/ConfirmModal";
import { useTranslation } from 'react-i18next';
import AuthContext from "../../contexts/AuthProvider";
import { getUserRole, USER_ROLES } from "../../utils/UsersPermissions";
import { API_URL } from "../../utils/config";
const baseUrl = API_URL;

const Loading = ({ className = "" }) => {


  
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
    >
      <circle fill="#6609F8" stroke="#6609F8" r="15" cx="40" cy="100">
        <animate
          attributeName="opacity"
          calcMode="spline"
          dur="2"
          values="1;0;1;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="-.4"
        ></animate>
      </circle>
      <circle fill="#6609F8" stroke="#6609F8" r="15" cx="100" cy="100">
        <animate
          attributeName="opacity"
          calcMode="spline"
          dur="2"
          values="1;0;1;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="-.2"
        ></animate>
      </circle>
      <circle fill="#6609F8" stroke="#6609F8" r="15" cx="160" cy="100">
        <animate
          attributeName="opacity"
          calcMode="spline"
          dur="2"
          values="1;0;1;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="0"
        ></animate>
      </circle>
    </svg>
  );
};

const VenueContent = ({ addAttraction, setAddAttraction, editingAttraction, setEditingAttraction, onVenueRefetch, venue, reviews }) => {
            const { t } = useTranslation("venue");

  const [isLoading, setIsLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  const [isDel, setIsDel] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [attractionToDelete, setAttractionToDelete] = useState(null);
  const [isDeletingAttraction, setIsDeletingAttraction] = useState(false);
  const { isAuthenticated } = useContext(AuthContext);

  const handleLoad = () => {
    setIsLoading(false); // Hide loading image when main image loads
  };

  const handleError = () => {
    setIsLoading(false); // Hide loading image on error
    setImageError(true); // Show fallback image
  };
   const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };
  const images = venue.images;
  console.log("Venue images:", images);
  const [current, setCurrent] = useState(0);
  const [editing, setEditing] = useState(false);
  const renderStars = (index, stars) => {
    stars -= 1;
    if (index > stars) {
      if (Math.round(2 * stars) % (2 * (index - 1)) === 1) {
        return (
          <svg
            width="20"
            height="19"
            viewBox="0 0 20 19"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id="half-star" x1="0" x2="100%" y1="0" y2="0">
                <stop offset="50%" stop-color="#ed5a29" />
                <stop offset="50%" stop-color="#888888" />
              </linearGradient>
            </defs>

            <path
              d="M9.04894 0.927052C9.3483 0.00574112 10.6517 0.00573993 10.9511 0.927051L12.4697 5.60081C12.6035 6.01284 12.9875 6.2918 13.4207 6.2918H18.335C19.3037 6.2918 19.7065 7.53141 18.9228 8.10081L14.947 10.9894C14.5966 11.244 14.4499 11.6954 14.5838 12.1074L16.1024 16.7812C16.4017 17.7025 15.3472 18.4686 14.5635 17.8992L10.5878 15.0106C10.2373 14.756 9.7627 14.756 9.41221 15.0106L5.43648 17.8992C4.65276 18.4686 3.59828 17.7025 3.89763 16.7812L5.41623 12.1074C5.55011 11.6954 5.40345 11.244 5.05296 10.9894L1.07722 8.10081C0.293507 7.53141 0.696283 6.2918 1.66501 6.2918H6.57929C7.01252 6.2918 7.39647 6.01284 7.53035 5.60081L9.04894 0.927052Z"
              fill="url(#half-star)"
            />
          </svg>
        );
      }
    }
    return (
      <svg
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill={index <= stars ? "#ed5a29" : "#888888"}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9.04894 0.927052C9.3483 0.00574112 10.6517 0.00573993 10.9511 0.927051L12.4697 5.60081C12.6035 6.01284 12.9875 6.2918 13.4207 6.2918H18.335C19.3037 6.2918 19.7065 7.53141 18.9228 8.10081L14.947 10.9894C14.5966 11.244 14.4499 11.6954 14.5838 12.1074L16.1024 16.7812C16.4017 17.7025 15.3472 18.4686 14.5635 17.8992L10.5878 15.0106C10.2373 14.756 9.7627 14.756 9.41221 15.0106L5.43648 17.8992C4.65276 18.4686 3.59828 17.7025 3.89763 16.7812L5.41623 12.1074C5.55011 11.6954 5.40345 11.244 5.05296 10.9894L1.07722 8.10081C0.293507 7.53141 0.696283 6.2918 1.66501 6.2918H6.57929C7.01252 6.2918 7.39647 6.01284 7.53035 5.60081L9.04894 0.927052Z" />
      </svg>
    );
  };

  const handleSlideClick = (index) => {
    setCurrent(index);
  };

  const navigate = useNavigate();

  const handleBack = () => {
    //handleLinkClick("Venues") // Navigate to the previous page
    navigate(-1);
  };

  const [visible, setVisible] = useState(venue.visible);

  const venueId = localStorage.getItem("VenueID");

  const handleDeleteAttraction = (attraction) => {
    if (!attraction?.id) return;
    setAttractionToDelete(attraction);
  };

  const handleCloseDeleteModal = () => {
    if (!isDeletingAttraction) setAttractionToDelete(null);
  };

  const handleConfirmDeleteAttraction = async () => {
    if (!attractionToDelete?.id) return;
    setIsDeletingAttraction(true);
    try {
      const response = await fetch(`${baseUrl}/api/v1/attnd-venue/deleteLocalAttraction`, {
        method: 'DELETE',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          lang: getLangFromLocalStorage(),
        },
        body: JSON.stringify({ attraction_id: attractionToDelete.id }),
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || err.message || t('errors.unknown'));
      }
      toast.success(t('toast.deleted'));
      setAttractionToDelete(null);
      onVenueRefetch?.();
    } catch (error) {
      toast.error(t('toast.error', { message: error.message }));
    } finally {
      setIsDeletingAttraction(false);
    }
  };

  const location = useLocation();
  const handleNavigateWithParams = (step) => {
    navigate(`/venues?step=${step}&edit=true`);
  };

  const handleToggle = async () => {
    if (editing) return;
    if (visible && !isDel) {
      setIsDel(true);
      return;
    }
    const loadingToast = toast.loading(
      t("")
    );
    setEditing(true);
    try {
      if (!isAuthenticated) {
        navigate("/login");
        return;
      }
      const response = await fetch(`${baseUrl}/api/v1/attnd-venue/visibility`, {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          lang: getLangFromLocalStorage(),
        },
        body: JSON.stringify({
          venue_id: venue.id, // The ID of the venue to update
          visible: !visible, // The new visibility status (true or false)
        }),
      });

      // Handle the response
      if (response.ok) {
        const data = await response.json();
        console.log(data.message); // Log success message
        toast.update(loadingToast, {
          render: visible
            ? t("successHidden")
            : t("successVisible"),
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
        setVisible((v) => !v);
        setEditing(false);
        setIsDel(false);
        return data; // Return the response data if needed
      } else {
        setEditing(false);
        if (response.status === 401) {
          navigate("/login");
          throw new Error("Unauthorized access. Please log in again.");
        } else if (response.status === 404) {
          alert("404 Not found.");
          navigate(-1);
          throw new Error("404 Not found.");
        }
        // Handle errors
        const errorData = await response.json();
        throw new Error(errorData.error); // Throw an error for further handling
      }
    } catch (error) {
      toast.update(loadingToast, {
        render: `Error: ${error.message || error}`,
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
    }
  };

  const [isFullScreen, setIsFullScreen] = useState(false);

  const openFullScreen = (index) => {
    setCurrent(index);
    setIsFullScreen(true);
  };

  const closeFullScreen = () => {
    setIsFullScreen(false);
  };

  const showNextImage = () => {
    setCurrent((prev) => (prev + 1) % images.length);
  };

  const showPrevImage = () => {
    setCurrent((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className={"page-venue"}>
      <div className={"content"}>
        {isFullScreen && (
          <div className="full-screen-overlay">
            <button className="close-button" onClick={closeFullScreen}>
              ✖
            </button>
            <button className="prev-button" onClick={showPrevImage}>
              ◀
            </button>
            {isLoading && <Loading className={"full-screen-image"} />}
            {/* Show main image or fallback image on error */}
            {imageError ? (
              <svg
                onClick={() => openFullScreen(current)}
                className="full-screen-image"
                // className="card-img"
                // style="width: 1em;height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 0m42.666667 0l938.666666 0q42.666667 0 42.666667 42.666667l0 938.666666q0 42.666667-42.666667 42.666667l-938.666666 0q-42.666667 0-42.666667-42.666667l0-938.666666q0-42.666667 42.666667-42.666667Z"
                  fill="#F7F7F7"
                />
                <path
                  d="M795.136 320.256a29.226667 29.226667 0 0 0-20.437333-9.386667l-222.378667-8.746666-16.853333 37.12 23.168 69.888-41.856 79.488 17.066666 64 42.24 54.954666 61.184-56.576a14.72 14.72 0 0 1 20.736 0.853334l78.72 85.162666a14.848 14.848 0 0 1 2.56 16.128 14.762667 14.762667 0 0 1-13.909333 8.533334l-215.68-8.448-10.752 30.890666 11.648 27.904 247.978667 9.6a29.354667 29.354667 0 0 0 30.464-28.245333L802.858667 341.333333a29.013333 29.013333 0 0 0-7.722667-21.077333z m-159.36 161.408a44.074667 44.074667 0 1 1 3.456-88.021333 44.074667 44.074667 0 0 1-3.456 88.021333z m-159.872 202.965333l7.466667-32.426666-175.146667 12.074666a14.677333 14.677333 0 0 1-12.117333-24.32l129.792-149.034666a14.677333 14.677333 0 0 1 21.632-0.512l43.434666 45.312-18.688-48.298667 32.938667-83.370667-30.378667-66.730666 12.672-38.656-238.848 16.469333a29.312 29.312 0 0 0-27.221333 31.36l24.234667 351.573333a29.013333 29.013333 0 0 0 9.941333 20.053334c5.888 5.077333 13.568 7.68 21.333333 7.168l213.248-14.72-14.293333-25.941334z"
                  fill="#CCCDCF"
                />
              </svg>
            ) : (
              <img
                // className="card-img"
                className="full-screen-image"
                src={images[current]}
                alt="Venue"
                onLoad={handleLoad}
                onError={handleError}
                // style={{display: isLoading ? 'none' : 'block'}}  // Hide main image while loading
              />
            )}
            <button className="next-button" onClick={showNextImage}>
              ▶
            </button>
          </div>
        )}
        <div className={"images-slider"}>
          {isLoading && <Loading />}
          {/* Show main image or fallback image on error */}
          {imageError ? (
            <svg
              onClick={() => openFullScreen(current)}
              // className="card-img"
              // style="width: 1em;height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 0m42.666667 0l938.666666 0q42.666667 0 42.666667 42.666667l0 938.666666q0 42.666667-42.666667 42.666667l-938.666666 0q-42.666667 0-42.666667-42.666667l0-938.666666q0-42.666667 42.666667-42.666667Z"
                fill="#F7F7F7"
              />
              <path
                d="M795.136 320.256a29.226667 29.226667 0 0 0-20.437333-9.386667l-222.378667-8.746666-16.853333 37.12 23.168 69.888-41.856 79.488 17.066666 64 42.24 54.954666 61.184-56.576a14.72 14.72 0 0 1 20.736 0.853334l78.72 85.162666a14.848 14.848 0 0 1 2.56 16.128 14.762667 14.762667 0 0 1-13.909333 8.533334l-215.68-8.448-10.752 30.890666 11.648 27.904 247.978667 9.6a29.354667 29.354667 0 0 0 30.464-28.245333L802.858667 341.333333a29.013333 29.013333 0 0 0-7.722667-21.077333z m-159.36 161.408a44.074667 44.074667 0 1 1 3.456-88.021333 44.074667 44.074667 0 0 1-3.456 88.021333z m-159.872 202.965333l7.466667-32.426666-175.146667 12.074666a14.677333 14.677333 0 0 1-12.117333-24.32l129.792-149.034666a14.677333 14.677333 0 0 1 21.632-0.512l43.434666 45.312-18.688-48.298667 32.938667-83.370667-30.378667-66.730666 12.672-38.656-238.848 16.469333a29.312 29.312 0 0 0-27.221333 31.36l24.234667 351.573333a29.013333 29.013333 0 0 0 9.941333 20.053334c5.888 5.077333 13.568 7.68 21.333333 7.168l213.248-14.72-14.293333-25.941334z"
                fill="#CCCDCF"
              />
            </svg>
          ) : (
            <img
              // className="card-img"
              onClick={() => openFullScreen(current)}
              src={images[current]}
              alt="Venue"
              onLoad={handleLoad}
              onError={handleError}
              // style={{display: isLoading ? 'none' : 'block'}}  // Hide main image while loading
            />
          )}

          {/*<img src={images[current]} alt="venue image"/>*/}
          <div className={"back"} onClick={handleBack}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                fill="#292929"
              />
              <path
                d="M13.2599 16.2802C13.0699 16.2802 12.8799 16.2102 12.7299 16.0602L9.19992 12.5302C8.90992 12.2402 8.90992 11.7602 9.19992 11.4702L12.7299 7.94016C13.0199 7.65016 13.4999 7.65016 13.7899 7.94016C14.0799 8.23016 14.0799 8.71016 13.7899 9.00016L10.7899 12.0002L13.7899 15.0002C14.0799 15.2902 14.0799 15.7702 13.7899 16.0602C13.6499 16.2102 13.4599 16.2802 13.2599 16.2802Z"
                fill="#292929"
              />
            </svg>

            <p>{t('back')}</p>
          </div>

          <div className={"venue-slider-line"}>
            <div className={"venue-slider"}>
              {images.map((_, index) => (
                <div
                  key={index}
                  className={"slider-button"}
                  onClick={() => handleSlideClick(index)}
                  style={
                    index === current
                      ? { background: "#ed5a29" }
                      : { background: "#EDEDED" }
                  }
                ></div>
              ))}
            </div>
          </div>
        </div>
        <div className={"venue-header"}>
          <div className={"venueRow"}>
            <p className={"venue-name"}>{venue.name}</p>
            <p className={"venue-price"}>
              {Number(venue.daily_rate || 0) !== 0
                ? Number(venue.daily_rate).toLocaleString()
                : Number(venue.hourly_rate).toLocaleString()}
              <span style={{ fontWeight: "400", fontSize: "16px" }}>
                {" "}
                {t('Per')} {Number(venue.daily_rate || 0) !== 0 ? t('pricePerDay') : t('pricePerHour')}
                {venue.per_attendees && (
                  <span> / {t('person')}</span>
                )}
              </span>
            </p>
          </div>
          <div className={"venueRow"}>
            <div style={{ display: "flex", flexDirection: "row" }}>
              {Array.from({ length: 5 }, (_, index) => (
                <span key={index}>{renderStars(index, venue.rating)}</span>
              ))}
            </div>
            <p>({venue.rating})</p>
          </div>
          <div className={"venueRow"}>
            <p className={"venue-desc"}>{venue.location}</p>
          </div>
          <div className={"venueRow"} style={{ cursor: "pointer" }}>
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="40" height="40" rx="20" fill="#F4F1FF" />
              <path
                d="M20.4997 30.7499H12.0797C10.5097 30.7499 9.21973 29.4899 9.21973 27.9299V13.0899C9.21973 11.5599 9.78973 10.3699 10.8297 9.71994C11.8797 9.05994 13.2397 9.07994 14.6497 9.77994L19.0897 11.9599C20.2997 12.5599 21.2497 14.0699 21.2497 15.4099V29.9999C21.2497 30.4099 20.9097 30.7499 20.4997 30.7499ZM12.5597 10.7499C12.2097 10.7499 11.8897 10.8299 11.6197 10.9999C11.0397 11.3599 10.7197 12.1099 10.7197 13.0899V27.9299C10.7197 28.6599 11.3297 29.2499 12.0797 29.2499H19.7497V15.4099C19.7497 14.6399 19.1297 13.6499 18.4197 13.3099L13.9797 11.1299C13.4697 10.8799 12.9897 10.7499 12.5597 10.7499Z"
                fill="#5507CF"
              />
              <path
                d="M26.81 30.75H20.5C20.09 30.75 19.75 30.41 19.75 30V18.42C19.75 18.19 19.85 17.98 20.03 17.84C20.21 17.7 20.43 17.64 20.66 17.69L21.13 17.79L27.67 19.25C29.66 19.69 30.66 20.86 30.72 22.85C30.73 22.85 30.73 22.95 30.73 23.06V26.84C30.72 29.4 29.37 30.75 26.81 30.75ZM21.25 29.25H26.81C28.57 29.25 29.22 28.6 29.22 26.84V22.98C29.17 21.61 28.65 21 27.34 20.71L21.25 19.35V29.25Z"
                fill="#5507CF"
              />
              <path
                d="M16.97 17.75H13.5C13.09 17.75 12.75 17.41 12.75 17C12.75 16.59 13.09 16.25 13.5 16.25H16.97C17.38 16.25 17.72 16.59 17.72 17C17.72 17.41 17.39 17.75 16.97 17.75Z"
                fill="#5507CF"
              />
              <path
                d="M16.97 21.75H13.5C13.09 21.75 12.75 21.41 12.75 21C12.75 20.59 13.09 20.25 13.5 20.25H16.97C17.38 20.25 17.72 20.59 17.72 21C17.72 21.41 17.39 21.75 16.97 21.75Z"
                fill="#5507CF"
              />
              <path
                d="M23.2197 25.75C21.5697 25.75 20.2197 24.4 20.2197 22.75V18.52C20.2197 18.29 20.3197 18.08 20.4997 17.93C20.6797 17.78 20.9097 17.73 21.1297 17.78L25.6297 18.79C25.9697 18.87 26.2197 19.17 26.2197 19.52V22.74C26.2197 24.4 24.8797 25.75 23.2197 25.75ZM21.7197 19.46V22.75C21.7197 23.58 22.3897 24.25 23.2197 24.25C24.0497 24.25 24.7197 23.58 24.7197 22.75V20.13L21.7197 19.46Z"
                fill="#5507CF"
              />
              <path
                d="M27.7197 25.7499C26.0697 25.7499 24.7197 24.3999 24.7197 22.7499V19.5299C24.7197 19.2999 24.8197 19.0899 24.9997 18.9499C25.1797 18.8099 25.4097 18.7499 25.6297 18.7999L27.6597 19.2499C29.6497 19.6899 30.6497 20.8599 30.7097 22.8499C30.7097 22.8699 30.7097 22.8899 30.7097 22.9099C30.6297 24.4999 29.3197 25.7499 27.7197 25.7499ZM26.2197 20.4599V22.7499C26.2197 23.5799 26.8897 24.2499 27.7197 24.2499C28.5097 24.2499 29.1597 23.6399 29.2097 22.8599C29.1597 21.5999 28.6397 20.9999 27.3397 20.7099L26.2197 20.4599Z"
                fill="#5507CF"
              />
            </svg>

            <p className={"venue-location"}>{venue.brand}</p>
          </div>
        </div>
        <div className={"venue-details"}>
          <div className={"venue-place-details"}>
            <PlaceDetails
              type={venue.venue_type}
              size={venue.size}
              capacity={venue.capacity}
              build={venue.build}
              rooms={venue.guest_rooms}
              brand={venue.brand}
              amenities={venue.amenities}
              latitude={venue.latitude}
              longitude={venue.longitude}
            />
          </div>
          <div className={"cost"}>
            <div>
              {/* Hide visibility toggle and edit button for viewers only */}
              {getUserRole() !== USER_ROLES.VIEWER && (
                <>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={visible}
                      onChange={handleToggle}
                    />
                    <span className="slider"></span>
                  </label>
                  <button
                    onClick={() => handleNavigateWithParams(1)}
                    className={"Edit_Venue"}
                  >
                    {t('edit')}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
        <div
          className={"local-attraction container"}
          style={
            !venue?.local_attractions || venue?.localAttractions?.length === 0
              ? { maxHeight: "80px" }
              : {}
          }
        >
          {/* Hide add attraction button for viewers only */}
          {getUserRole() !== USER_ROLES.VIEWER && (
            <button
              onClick={() => setAddAttraction(true)}
              style={{ width: "131px" }}
            >
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.5 12.75H6.5C6.09 12.75 5.75 12.41 5.75 12C5.75 11.59 6.09 11.25 6.5 11.25H18.5C18.91 11.25 19.25 11.59 19.25 12C19.25 12.41 18.91 12.75 18.5 12.75Z"
                  fill="white"
                />
                <path
                  d="M12.5 18.75C12.09 18.75 11.75 18.41 11.75 18V6C11.75 5.59 12.09 5.25 12.5 5.25C12.91 5.25 13.25 5.59 13.25 6V18C13.25 18.41 12.91 18.75 12.5 18.75Z"
                  fill="white"
                />
              </svg>
                  {t('addSite')}
            </button>
          )}
          <LocalAttraction
            localAttractions={venue.local_attractions}
            onEdit={getUserRole() !== USER_ROLES.VIEWER ? setEditingAttraction : undefined}
            onDelete={getUserRole() !== USER_ROLES.VIEWER ? handleDeleteAttraction : undefined}
          />
        </div>
        <Reviews reviews={reviews} />
        <div className={"Venue-Mobile"}>
          <button onClick={handleBack} className={"VenueCancel"}>
                {t('cancel')}
          </button>
          {/* Hide edit button for viewers only */}
          {getUserRole() !== USER_ROLES.VIEWER && (
            <button
              onClick={() => handleNavigateWithParams(1)}
              className={"VenueConfirm"}
            >
                  {t('edit')}
            </button>
          )}
        </div>
        {venue.id === Number(venueId) && (
          <div
            className={"VenueDesktop"}
            style={{ width: "100%", height: "300px" }}
          ></div>
        )}
      </div>
      {isDel && (
        <div className="delete-event-modal-overlay">
          <div className="delete-account-modal">
            <div className={"Header"}>
              <p>                {t('hideVenue')}</p>
              <svg
                onClick={() => setIsDel(false)}
                style={{ cursor: "pointer" }}
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="30" height="30" rx="15" fill="#DBDBDB" />
                <path
                  d="M9.92188 20.4531C9.79167 20.3229 9.70573 20.1719 9.66406 20C9.6224 19.8229 9.6224 19.6484 9.66406 19.4766C9.70573 19.3047 9.78906 19.1562 9.91406 19.0312L13.5781 15.3672L9.91406 11.7109C9.78906 11.5859 9.70573 11.4375 9.66406 11.2656C9.6224 11.0938 9.6224 10.9219 9.66406 10.75C9.70573 10.5729 9.79167 10.4193 9.92188 10.2891C10.0469 10.1641 10.1953 10.0807 10.3672 10.0391C10.5443 9.99219 10.7188 9.99219 10.8906 10.0391C11.0677 10.0807 11.2188 10.1615 11.3438 10.2812L15 13.9453L18.6641 10.2891C18.7891 10.1641 18.9349 10.0807 19.1016 10.0391C19.2734 9.99219 19.4453 9.99219 19.6172 10.0391C19.7943 10.0807 19.9453 10.1667 20.0703 10.2969C20.2057 10.4219 20.2943 10.5729 20.3359 10.75C20.3776 10.9219 20.3776 11.0938 20.3359 11.2656C20.2943 11.4375 20.2083 11.5859 20.0781 11.7109L16.4297 15.3672L20.0781 19.0312C20.2083 19.1562 20.2943 19.3047 20.3359 19.4766C20.3776 19.6484 20.3776 19.8229 20.3359 20C20.2943 20.1719 20.2057 20.3203 20.0703 20.4453C19.9453 20.5755 19.7943 20.6641 19.6172 20.7109C19.4453 20.7526 19.2734 20.7526 19.1016 20.7109C18.9349 20.6693 18.7891 20.5833 18.6641 20.4531L15 16.7969L11.3438 20.4609C11.2188 20.5807 11.0677 20.6641 10.8906 20.7109C10.7188 20.7526 10.5443 20.7526 10.3672 20.7109C10.1953 20.6641 10.0469 20.5781 9.92188 20.4531Z"
                  fill="#464646"
                />
              </svg>
            </div>
            <div className={"Content"}>
              <div className={"Info"}>
                <h5>                {t('hideVenueConfirmation')}
</h5>
                <p>
                  {t("hideVenueNote")}
                </p>
              </div>
              <div className={"Buttons"}>
                <button onClick={() => setIsDel(false)} className={"Cancel"}>
   {t('cancel')}                </button>
                <button className={"Del"} onClick={handleToggle}>
                  {isDeleting ? t("loading") : t("yesHide")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {addAttraction && (
        <div className="delete-event-modal-overlay">
          <AddAttraction
            id={venue.id}
            baseUrl={baseUrl}
            setAddAttraction={setAddAttraction}
          />
        </div>
      )}
      {editingAttraction != null && (
        <div className="delete-event-modal-overlay">
          <EditAttraction
            baseUrl={baseUrl}
            venueId={venue.id}
            attraction={editingAttraction}
            setEditAttraction={setEditingAttraction}
            onSaved={onVenueRefetch}
          />
        </div>
      )}
      <ConfirmModal
        isOpen={!!attractionToDelete}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDeleteAttraction}
        title={t('deleteAttractionTitle')}
        message={t('deleteAttractionConfirm')}
        confirmLabel={t('yesDelete')}
        cancelLabel={t('cancel')}
        isLoading={isDeletingAttraction}
        loadingLabel={t('loading')}
        confirmVariant="danger"
      />
      <ToastContainer />
    </div>
  );
};
export default VenueContent;
